import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useNavigate } from "react-router-dom";
import { useRetrieveDivision, useRetrieveDivisionsBySeasonId, useUpdateDivision, } from "../api/DivisionApiProvider";
import { ErrorView } from "../nav/Error";
import { Loading } from "../nav/Loading";
import ErrorSnackbar from "../utils/ErrorSnackbar";
import { useNumericParams } from "../utils/useNumericParams";
import { DivisionForm } from "./DivisionForm";
export var UpdateDivision = function () {
    var id = useNumericParams().id;
    var navigate = useNavigate();
    var _a = useRetrieveDivision({ id: id }), division = _a.data, isLoading = _a.isLoading, error = _a.error;
    var _b = useRetrieveDivisionsBySeasonId({
        seasonId: division === null || division === void 0 ? void 0 : division.season,
        enabled: !!(division === null || division === void 0 ? void 0 : division.season),
    }), _c = _b.data, divisions = _c === void 0 ? [] : _c, divisionsLoading = _b.isLoading;
    var mutation = useUpdateDivision({
        onMutate: function () { },
        onSuccess: function (data) {
            var updated = data.data;
            navigate("/seasons/".concat(updated.season, "/"));
        },
        onError: function () { },
    });
    if (!id) {
        return _jsx(ErrorView, { error: new Error("Missing division id") });
    }
    if (isLoading || mutation.isLoading || divisionsLoading) {
        return _jsx(Loading, {});
    }
    if (error || !division) {
        return _jsx(ErrorView, { error: error || new Error("Failed to load division") });
    }
    return (_jsxs(_Fragment, { children: [_jsx(ErrorSnackbar, { open: mutation.isError, message: "Failed to update division. Please try again.", onClose: function () { } }), _jsx(DivisionForm, { onSubmit: function (data) { return mutation.mutate(data); }, seasonId: division.season, existingDivisions: divisions, division: division })] }));
};
